

import { CadastroDocumentoTipo, ImovelDocumentos } from '@usucampeao/lib-reurb-simplificado';
import { PropertyAcquisitionDocument } from '../property/property-occupation/property-acquisition-document.enum';
import { PropertyOwnershipDocument } from '../property/property-occupation/property-ownership-document.enum';
import { DocumentFileSubtype } from './document-file-subtype.enum';
import { DocumentReferenceType } from './document-reference-type.enum';
import { OwnerDocument } from './owner-document.enum';
import { StatusDocument } from './status-document.enum';

export enum AdminDocumentos {
  CESSAO_DIREITO = 'CESSAO_DIREITO',
  COMPROVANTE_CONTA = 'COMPROVANTE_CONTA',
  CONTRATO_COMPRA_VENDA = 'CONTRATO_COMPRA_VENDA',
  RECIBO = 'RECIBO',
  FACHADA = 'FACHADA',
  CERTIDAO_CASAMENTO = 'CERTIDAO_CASAMENTO',
  CERTIDAO_DIVORCIO = 'CERTIDAO_DIVORCIO',
  CERTIDAO_NASCIMENTO = 'CERTIDAO_NASCIMENTO',
  CERTIDAO_OBITO = 'CERTIDAO_OBITO',
  COMPROVANTE_ENDERECO = 'COMPROVANTE_ENDERECO',
  COMPROVANTE_RENDA = 'COMPROVANTE_RENDA',
  IR = 'IR',
  HOLERITE = 'HOLERITE',
}

export type DocumentFileType = OwnerDocument | ImovelDocumentos | PropertyAcquisitionDocument | PropertyOwnershipDocument | CadastroDocumentoTipo | AdminDocumentos;

export class DocumentFileDto {
  id: string;
  name?: string;
  registrationId: string;
  refId: string;
  refType: DocumentReferenceType;
  type: DocumentFileType;
  subtype: DocumentFileSubtype;
  approvedDisapprovedDate: Date;
  approvedDisapprovedUserId: string;
  status: StatusDocument;
  justification: string;
  reasonRejection: string;
  createdAt: Date;
  publico: string | boolean;
  userCreationId: string;
  usuarioCriacaoNome: string;
  updatedAt: Date;
  updateUserId: string;
}
